module.exports = __webpack_public_path__ + "front/img/banner-wap.4dbef144.png";